import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: {},
};

const UserSlice = createSlice({
  name: "user",
  initialState: initialState,
  reducers: {
    updateUser: (state, action) => {
      state.user = action.payload;
    },
    getUser: (state, action) => {
      state.user = action.payload;
    },
  },
});

export const { updateUser } = UserSlice.actions;

export default UserSlice.reducer;
